import React, { useState } from 'react';

interface Props {
  collapsed: boolean;
  cardClassName?: string;
  headerClassName?: string;
  buttonClassName?: string;
  renderHeader: () => React.ReactElement | null;
  ignoreDefaultButtonClassName?: boolean;
  ignoreCardClassName?: boolean;
}

export const AccordionCard: React.FC<Props> = ({
  children,
  collapsed: initialCollapsed,
  cardClassName,
  headerClassName,
  buttonClassName,
  renderHeader,
  ignoreDefaultButtonClassName = false,
  ignoreCardClassName = false
}) => {
  const [collapsed, setCollapsed] = useState(initialCollapsed);
  const defaultButtonClassName = `btn btn-flat-primary text-large justify-content-start d-flex align-items-center pl-0`;
  const defaultCardClassName = ignoreCardClassName ? `` : `card`;
  return (
    <div className={`${defaultCardClassName}${cardClassName ? ` ${cardClassName}` : ''}`}>
      <div className={`pl-0 card-header${headerClassName ? ` ${headerClassName}` : ''}`}>
        <button
          className={`${ignoreDefaultButtonClassName ? '' : defaultButtonClassName}${collapsed ? ' collapsed' : ''}${
            buttonClassName ? ` ${buttonClassName}` : ''
          }`}
          data-toggle="collapse" // needed to remove the background-color on the <button>
          onClick={() => setCollapsed(!collapsed)}
        >
          <i className="icon icon-sm mr-2 text-secondary">keyboard_arrow_right</i>
          {renderHeader()}
        </button>
      </div>
      <div className={`collapse${collapsed ? '' : ' show'}`}>
        <div className="card-body pt-0">{children}</div>
      </div>
    </div>
  );
};
